export default __webpack_public_path__ + "static/media/mentoring.17933b25.png";